module.exports = __webpack_public_path__ + "static/media/Stadtticket_Icon_freistehend~bpWSsPcY.fca23a52.svg";